<template>
  <div>
    <div
      class="meeting-type-card d-flex flex-column justify-content-between align-items-start p-0"
    >
      <div class="header d-flex flex-column flex-grow-1 px-3 pt-3 w-100">
        <div class="d-flex flex-row w-100">
          <div
            class="d-flex flex-column justify-content-start align-items-startflex-grow-1 pointer w-100"
            @click.prevent="$emit('edit')"
          >
            <h4 class="mr-3">
              <v-clamp autoresize :max-lines="1">
                {{ meetingType.name }}
              </v-clamp>
            </h4>
            <div class="pb-2">
              {{ duration }}
            </div>
          </div>
          <div>
            <HMIconButton
              :icon="['far', 'ellipsis-h']"
              :id="`popover-${meetingType.id}`"
            />
            <HMPopover :target="`popover-${meetingType.id}`">
              <HMPopoverMenuItem @click="$emit('duplicate')">
                {{ $t('MARKETING.LINKS.DUPLICATE') }}
              </HMPopoverMenuItem>
              <HMPopoverMenuItem @click="$emit('delete')">
                <span class="d-flex justify-content-between align-items-center">
                  {{ $t('MARKETING.LINKS.DELETE_MEETING_TYPE') }}
                  <i class="far fa-trash-alt c-coral ml-4"></i>
                </span>
              </HMPopoverMenuItem>
            </HMPopover>
          </div>
        </div>
      </div>
      <div class="footer pointer w-100" @click="copy">
        <hr />
        <div class="px-3 pb-3">
          <i class="far fa-link c-brand-color mr-2"></i>
          {{ $t('MARKETING.TEXT.COPY_MEETING_LINK') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VClamp from 'vue-clamp';
import * as EventUtils from '../../../core/utils/events';
import { notify } from '../../utils/notify';
import { getStudentViewURL } from '../../router/custom-domain-utils';
import { mapGetters } from 'vuex';

export default {
  name: 'MeetingTypeCard',
  components: {
    VClamp,
  },
  props: {
    meetingType: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
    }),
    duration() {
      return EventUtils.humanizeDuration(
        this.meetingType.duration_minutes,
        'minutes'
      );
    },
  },
  methods: {
    copy() {
      const url = getStudentViewURL(this.teacherStudioUrl, '/meet', null);
      const value = `${url}/${this.meetingType.slug}`;
      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED'), value);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.meeting-type-card {
  border: 1px solid $light-gray;
  border-radius: $border-radius;
  //max-width: 350px;

  .footer {
    max-height: 80px;
  }
}
</style>
